export function formatDateInput(value?: Date | string | null): string {
  if (!value) return '';

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function addBusinessDaysFromLoan(
  dateValue: string,
  prazoEmprestimo?: number | string | null
): string {
  if (!dateValue) return '';

  const prazo = Number(prazoEmprestimo);
  const diasEmprestimo = Number.isFinite(prazo) && prazo > 0 ? prazo : 15;

  const date = new Date(`${dateValue}T12:00:00`);
  date.setDate(date.getDate() + diasEmprestimo);

  const dayOfWeek = date.getDay();
  if (dayOfWeek === 6) {
    date.setDate(date.getDate() + 2);
  } else if (dayOfWeek === 0) {
    date.setDate(date.getDate() + 1);
  }

  return formatDateInput(date);
}

export function calculateLateFee(
  dataDevolucao: string,
  dataPrevista?: Date | string | null,
  moraAtraso?: number | string | null
): number {
  if (!dataDevolucao || !dataPrevista) return 0;

  const devolucao = new Date(`${dataDevolucao}T12:00:00`);
  const prevista =
    dataPrevista instanceof Date
      ? new Date(dataPrevista)
      : new Date(`${formatDateInput(dataPrevista)}T12:00:00`);

  if (Number.isNaN(devolucao.getTime()) || Number.isNaN(prevista.getTime())) return 0;
  if (devolucao <= prevista) return 0;

  const diff = devolucao.getTime() - prevista.getTime();
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  const moraAtrasoDiaria = Number(moraAtraso ?? 0);
  if (!Number.isFinite(moraAtrasoDiaria) || moraAtrasoDiaria <= 0) return 0;

  return Number((days * moraAtrasoDiaria).toFixed(2));
}
